<template>
    <div class="navbar">
        <hamburger
            id="hamburger-container"
            :is-active="sidebar.opened"
            class="hamburger-container"
            @toggleClick="toggleSideBar"
        />
        <div class="left-text">
            {{ title }}
        </div>

        <!-- <breadcrumb
            id="breadcrumb-container"
            class="breadcrumb-container"
        /> -->
        <div class="right-menu">
            <template v-if="device!=='mobile'">
<!--                <search-->
<!--                    id="header-search"-->
<!--                    class="right-menu-item"-->
<!--                />-->

                <error-log class="errLog-container right-menu-item hover-effect"/>

                <screenfull
                    id="screenfull"
                    class="right-menu-item hover-effect"
                />

                <el-tooltip
                    content="按钮尺寸"
                    effect="dark"
                    placement="bottom"
                >
                    <size-select
                        id="size-select"
                        class="right-menu-item hover-effect"
                    />
                </el-tooltip>
                <el-dropdown class="right-menu-item hover-effect" style="width: 40px;text-align: center;"
                             trigger="click"
                >
                    <div>
                        <span class="message-badge" v-if="unread && unread > 0">{{unread}}</span>
                        <i class="el-icon-bell" style="font-weight:700;"></i>
                    </div>
                    <el-dropdown-menu slot="dropdown" id="message-box" style="width:336px;">
                        <el-tabs :stretch="true" v-model="message_type">
                            <el-tab-pane name="notice">
                                <span slot="label">未读消息 ({{message_total}})</span>
                                <div :class="item.isRead?'message-line readed':'message-line'" @click="readMsg(item)" v-for="item of message_list" :key="item.id">
                                    <div class="message-line-box">
                                        <div class="message-line-title">
                                            {{item.title}}
                                        </div>
                                        <div class="message-line-desc">
                                            {{item.con}}
                                        </div>
                                        <div class="message-line-btns">
                                            {{item.addTime}}
                                        </div>
                                    </div>
                                </div>
                                <div class="message-line-footer">
                                    <div class="message-line-footer-btn1" @click="readAll" :disabled="is_post">
                                        全部已读
                                    </div>
                                    <div class="message-line-footer-btn2" :disabled="is_post" @click="showMany">
                                        我的消息
                                    </div>
                                </div>
                            </el-tab-pane>
<!--                            <el-tab-pane label="" name="task">-->
<!--                                <span slot="label">任务 (0)</span>-->
<!--                            </el-tab-pane>-->
                        </el-tabs>
                    </el-dropdown-menu>
                </el-dropdown>


            </template>
            <el-dropdown
                class="avatar-container right-menu-item hover-effect"
                trigger="click"
            >
                <!--<div class="avatar-wrapper">-->
                <!--<i class="el-icon-caret-bottom" />-->
                <!--</div>-->
                <div style="font-size:16px;">
                    <el-avatar shape="circle" :size="25"
                               style="height: 25px;line-height:50px;display:inline-block;position: relative;top: 6px;"
                               :src="userinfo.avatar"
                    ></el-avatar>
                    {{ userinfo.name }}
                    <i class="el-icon-caret-bottom"/>
                </div>
                <el-dropdown-menu slot="dropdown">
                    <router-link to="/dashboard">
                        <el-dropdown-item>
                            <svg-icon icon-class="dashboard"/>
                            仪表盘
                        </el-dropdown-item>
                    </router-link>
                    <router-link to="/account/basic">
                        <el-dropdown-item>
                            <svg-icon icon-class="user"/>
                            个人中心
                        </el-dropdown-item>
                    </router-link>
                    <el-dropdown-item
                        divided
                        @click.native="logout"
                    >
                        <span style="display:block;"><svg-icon icon-class="logout"/> 退出登录</span>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>

    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import ErrorLog from '@/components/ErrorLog'
import Screenfull from '@/components/Screenfull'
import SizeSelect from '@/components/SizeSelect'
import Search from '@/components/HeaderSearch'
import DefaultSettings from '@/settings'
import request from '@/utils/request'

export default {
    components: {
        Breadcrumb,
        Hamburger,
        ErrorLog,
        Screenfull,
        SizeSelect,
        Search
    },
    data() {
        return {
            title: DefaultSettings.logoText,
            message_type: 'notice',
            message_list:[

            ],
            message_total:0,
            unread:0,
            is_post:false
        }
    },
    computed: {
        ...mapGetters([
            'sidebar',
            'avatar',
            'device',
            'name',
            'userinfo',
            'message_unread',
            'message'
        ])
    },
    methods: {
        toggleSideBar() {
            this.$store.dispatch('app/toggleSideBar')
        },
        async logout() {
            await this.$store.dispatch('user/logout')
            this.$router.replace(`/auth/login?redirect=dashboard`)
        },
        readMsg(item){
            //点击read
            if(item.isRead){
                return false;
            }
            if(this.is_post){
                return false;
            }
            this.is_post = true;
            request.post("message/read",{ids:[item.id]}).then(res=>{
                item.isRead = 1;
                this.is_post = false;
                this.getList();
            }).catch(err=>{
                this.is_post = false;
            });
        },
        showMany(){
            this.$router.push({name:"account_message"});
        },
        readAll(){
            this.$confirm('此操作将您的所有消息改为已读状态, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(()=>{
                this.is_post = true;
                request.get("message/read_all").then(res=>{
                    for(let item of this.message_list){
                        item.isRead = 1;
                    }
                    this.unread = res.data;
                    this.$bus.emit("msg_read_all");
                    // this.$store.dispatch("message/set_unread",res.data);
                    this.$message.success("所有消息已改为已读状态");
                    this.is_post = false;
                }).catch(err=>{
                    this.is_post = false;
                });
            });
        },
        //未读消息列表
        getList(){
            request.post("message/unread_list",{pageNum:1,pageSize:5}).then(res=>{
                this.message_list = res.data.data.list;
                this.message_total = res.data.data.total;
                this.unread = res.data.unread;
            });
        },
        //全部消息列表
        // getList(){
        //     request.post("message/list",{pageNum:1,pageSize:5}).then(res=>{
        //         this.message_list = res.data.data.list;
        //         this.message_total = res.data.data.total;
        //         this.unread = res.data.unread;
        //     });
        // },
        msg_changed(){
            // if(type == "read"){
            //     for(let i of this.message_list){
            //         if(i.id == item.id){
            //             i.isRead = 1;
            //         }
            //     }
            // }else if(type == "readall"){
            //
            // }else if(type == "del"){
            //
            // }else if(type == "delall"){
            //
            // }
            // console.log("事件:",type,item);
            this.getList();
        }
    },
    created() {
        this.$bus.on("nav_msg_change",this.msg_changed);
    },
    mounted() {
        this.getList();
    },
    beforeDestroy() {
        this.$bus.off("nav_msg_change");
    }
}
</script>

<style lang="scss" scoped>
@import "@/styles/element-variables.scss";

.message-line {
    width: 100%;
    padding: 10px 20px;
    display: flex;
    align-items: center;
    font-size: 12px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    cursor: pointer;
    transition: all 0.5s;
    position: relative;

    &.readed {
        opacity: 0.5;
    }

    background:rgba(217, 236, 255,0.4);

    &:hover {
        background: rgb(179, 216, 255);
    }

    .message-line-icon {
        width: 55px;

        .message-line-icon-item {
            display: inline-block;
            text-align: center;
            color: #fff;
            line-height: 35px;
            height: 35px;
            width: 35px;
            background: #f96;
            border-radius: 50%;
        }
    }

    .message-line-box {
        width: 250px;

        .message-line-title {
            font-weight: 500;
            font-size: 14px;
            margin-bottom: 12px;
        }

        .message-line-desc {
            font-weight: 200;
            font-size: 12px;
            color: #888;
            margin-bottom: 5px;
        }

        .message-line-time {
            color: #888;
        }

        .message-line-btns {
            position: absolute;
            top: 10px;
            right: 20px;

            .tabs {
                display: inline-block;
                padding: 3px 5px 2px 5px;
                border: 1px solid #dedede;
                font-size: 12px;
            }
        }
    }
}

.message-line-footer {
    width: 100%;
    display: flex;
    justify-content: space-around;
    font-size: 14px;
    color: #333;

    .message-line-footer-btn1 {
        padding-top: 14px;
        padding-bottom: 10px;
        text-align: center;
        display: inline-block;
        width: 50%;
        border-right: 1px solid rgba(0, 0, 0, 0.1);
        transition: all 0.5s;
        cursor: pointer;

        &:hover {
            color: $--color-primary;
        }
    }

    .message-line-footer-btn2 {
        padding-top: 14px;
        padding-bottom: 10px;
        text-align: center;
        width: 50%;
        display: inline-block;
        transition: all 0.5s;
        cursor: pointer;

        &:hover {
            color: $--color-primary;
        }
    }
}

.navbar {
    height: 50px;
    overflow: hidden;
    position: relative;
    background: #fff;
    box-shadow: 0 1px 4px rgba(0, 21, 41, .08);
    
    .hamburger-container {
        line-height: 46px;
        height: 100%;
        float: left;
        cursor: pointer;
        transition: background .3s;
        -webkit-tap-highlight-color: transparent;
        &:hover {
            background: rgba(0, 0, 0, .025)
        }
    }

    .breadcrumb-container {
        float: left;
    }

    .errLog-container {
        display: inline-block;
        vertical-align: top;
    }

    .left-text {
        float: left;
        line-height: 50px;
        margin-right: 20px;
        color: $--color-primary;
    }

    .right-menu {
        float: right;
        height: 100%;
        line-height: 50px;

        &:focus {
            outline: none;
        }

        .right-menu-item {
            display: inline-block;
            padding: 0 8px;
            height: 100%;
            font-size: 18px;
            color: #5a5e66;
            vertical-align: text-bottom;
            position: relative;

            .message-badge {
                top: 1px;
                right: 1px;
                height: 21px;
                width: 21px;
                text-align: center;
                line-height: 20px;
                padding: 0 0px;
                font-size: 12px;
                color: #fff;
                background: rgba(255, 77, 79, 1);
                border-radius: 50%;
                display: inline-block;
                position: absolute;
            }

            &.hover-effect {
                cursor: pointer;
                transition: background .3s;

                &:hover {
                    background: rgba(0, 0, 0, .025)
                }
            }
        }

        .avatar-container {
            margin-right: 30px;

            .avatar-wrapper {
                margin-top: 5px;
                position: relative;

                .user-avatar {
                    cursor: pointer;
                    width: 40px;
                    height: 40px;
                    border-radius: 10px;
                }

                .el-icon-caret-bottom {
                    cursor: pointer;
                    position: absolute;
                    right: -20px;
                    top: 25px;
                    font-size: 12px;
                }
            }
        }
    }
}
</style>
